import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { SESSION_ID_KEY, USER_PHONE_KEY } from '../../models/consts';
import { canonicalUuid } from '../technical-identifiers';

export const confirmGuard = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);

  // Yandex-флоу приходит на /login/verify прямым редиректом с бэкенда, минуя
  // authorization.component.ts, поэтому localStorage ещё не заполнен - в этом случае
  // валидность подтверждают сами query-параметры редиректа (session_id + typeVerify).
	const querySessionId = canonicalUuid(route.queryParamMap.get('session_id'));
  const queryTypeVerify = route.queryParamMap.get('typeVerify');
  if (querySessionId && queryTypeVerify) {
    return true;
  }

	const session_id = canonicalUuid(localStorage.getItem(SESSION_ID_KEY));
  const userPhone: string | null = localStorage.getItem(USER_PHONE_KEY);
  if (session_id && userPhone) {
    return true;
  }

  return router.createUrlTree(['/login'], {
    queryParams: {
      session_id,
    },
  });
};
